import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { formatNumber } from "../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getTransactions,
  getCreditLine,
  getCurrency,
} from "../../../Redux/reducer/credit-line";
import {
  getTransactionsByStatus,
  setCurrency,
} from "../../../Redux/actions/credit-line";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import ToggleSwitch from "canvas-core-react/lib/ToggleSwitch";
import Card from "canvas-core-react/lib/Card";
import NoFee from "../../../../static/images/noFee.svg";

import SimpleBar from "simplebar-react";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { getBillStatusKey } from "../../utils/utilities";

/* DRAFT - DDAY - PENDING - APPROVED_PARTIALLY - APPROVED
   DELETED - VALIDATED - ACCEPTED_PARTIALLY - ACCEPTED
   PROCESSED - PAID - PAID_REJECTED */

const Transactions = (props) => {
  const dispatch = useDispatch();
  const [readyComponent, setReadyComponent] = useState(false);
  const transactions = useSelector((state) => getTransactions(state));
  const creditLines = useSelector((state) => getCreditLine(state));
  const currency = useSelector((state) => getCurrency(state));
  const loggedUser = useSelector((state) => getSessionInfo(state));
  const { t } = useTranslation();
  const history = useHistory();

  const handleRedirect = () => history.push("/bills/rejected");

  const baseUrl =
    true === props.fromProvider ? "/providerSite/bills" : "/bills/all";

  useEffect(() => {
    let _isMounted = true;
    async function fetchTransactions() {
      return await dispatch(getTransactionsByStatus());
    }

    fetchTransactions().then(() => {
      if (_isMounted) {
        setReadyComponent(true);
      }
    });

    return () => {
      _isMounted = false;
    };
  }, []);

  const changeCurrency = (boolCurrency) => {
    const reverseCreditLines = creditLines.filter((creditLine) => creditLine.isReverseLine)
    dispatch(
      setCurrency(reverseCreditLines[boolCurrency == false ? 0 : 1].currencyCode)
    );
  };

  const getElements = () => {
    let list =
      true === props.fromProvider
        ? transactions.list
        : transactions.list.filter(
            (transaction) => currency === transaction.currency.currencyCode
          );

    return list.map((item, idx) => {
      let billStatus = getBillStatusKey(item.status, loggedUser.userType);
      return (
        <div key={`transaction-item-${idx}`} className="row">
          <Link
            className="row"
            to={
              item.status !== "PAID_REJECTED"
                ? `${baseUrl}?status=${item.status}`
                : `bills/rejected`
            }
          >
            <div className="col-4 status">
              {t(`general.billStates.${billStatus}`)}
            </div>
            <div className="col-3 qty">{item.quantity}</div>
            <div className="col-5 mount">
              {formatNumber(item.amount, item.currency.currencySymbol)}
            </div>
          </Link>
        </div>
      );
    });
  };

  const hasRejectedBills = transactions?.list?.some(
    ({ status }) => status === "PAID_REJECTED"
  );

  return (
    <div
      className={`row ${props.className}`}
      style={{ height: "fit-content", paddingLeft: 0 }}
    >
      <div className={`transactions-container w-100`}>
        {readyComponent ? (
          <React.Fragment>
            <div className="flex-element">
              <h3>{t("dashboard.transactionsByStatus.title")}</h3>
              {true !== props.fromProvider && creditLines.length > 1 && (
                <ToggleSwitch
                  id="currency"
                  name="currency"
                  className="left-flex"
                  value={`1`}
                  onChange={(e) => changeCurrency(e.target.checked)}
                  label={t(`general.currency.${currency}`)}
                />
              )}
            </div>
            <div className="transactions">
              <SimpleBar
                forceVisible="y"
                style={{ maxHeight: 350, width: "100%" }}
              >
                <div className="header-transaction row">
                  <div className="col-4">
                    {t("dashboard.transactionsByStatus.table.status")}
                  </div>
                  <div className="col-3">
                    {t("dashboard.transactionsByStatus.table.quantity")}
                  </div>
                  <div className="col-5">
                    {t("dashboard.transactionsByStatus.table.amount")}
                  </div>
                </div>
                <div className="content">{getElements()}</div>
              </SimpleBar>
            </div>
          </React.Fragment>
        ) : (
          <div className="linear-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}
      </div>

      {hasRejectedBills && loggedUser.userType === "CSA" && (
        <Card className="d-flex flex-column align-items-center mt-5 w-50">
          <img src={NoFee} />
          <p className="text-center mb-4 mt-2">
            {t("dashboard.transactionsByStatus.table.description")}
          </p>
          <PrimaryButton
            onClick={handleRedirect}
            className="button-transaccion-fix"
          >
            {t("dashboard.transactionsByStatus.table.button")}
          </PrimaryButton>
        </Card>
      )}
    </div>
  );
};

export default Transactions;
